import { API_BASE_URL } from "./apiConfig";
import { logApiContext } from "../config/apiBaseUrl";

const API_URL = `${API_BASE_URL}/api/users`;
const logRequest = (action, url) =>
  logApiContext(`userService:${action}`, { url, API_URL });

const authHeaders = () => ({
  "Content-Type": "application/json",
  Authorization: `Bearer ${localStorage.getItem("token")}`,
});

export const getMyProfile = async () => {
  const url = `${API_URL}/me`;
  logRequest("getMyProfile", url);
  const response = await fetch(url, {
    method: "GET",
    headers: authHeaders(),
  });

  if (!response.ok) {
    const text = await response.text();
    throw new Error(text || "No se pudo obtener el perfil");
  }

  return await response.json();
};

export const updateMyProfile = async (payload) => {
  const url = `${API_URL}/me`;
  logRequest("updateMyProfile", url);
  const response = await fetch(url, {
    method: "PUT",
    headers: authHeaders(),
    body: JSON.stringify(payload),
  });

  if (!response.ok) {
    const text = await response.text();
    throw new Error(text || "No se pudo actualizar el perfil");
  }

  return await response.json();
};
